import { styled } from 'styled-components';
import { dontForwardProps } from '../../../util';
export const DrawerImage = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1a4g05v-0"
})(["flex:none;background-image:url(", ");background-size:cover;width:100%;height:180px;"], props => props.imgSrc);